import React, { useState,useEffect } from 'react';
import PdfProspectionSevice from "../service/PdfProspectionSevice";
import {urlDirectus} from "../config/Globals";

export const DownloadModalComponent = ({
                                           showModal,
                                           closeModal
}) => {

    const[PdfProspection, setPdfProspection] = useState([]);
    const[loadingPdfProspection, setLoadingPdfProspection] = useState(1);
    const fetchPdfProspection = async() => {
        try{
            const data = await PdfProspectionSevice.findAll();
            setPdfProspection(data);
            setLoadingPdfProspection(false);
        }catch (error){

        }
    }
    useEffect(() => {
        fetchPdfProspection();
    }, []);


    // Fonction pour fermer UNIQUEMENT si on clique sur le fond noir
    const handleBackdropClick = (e) => {
        // e.target est l'élément cliqué, e.currentTarget est l'élément qui porte l'événement (la div principale)
        if (e.target === e.currentTarget) {
            closeModal();
        }
    };

    return (
        <>
            <div
                onClick={handleBackdropClick}
                className={`modal fade ${showModal ? 'show d-block' : 'd-none'}`}
                tabIndex="-1"
                aria-labelledby="downloadModalLabel"
                aria-hidden={!showModal}
                style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }} // Ajoute un fond semi-transparent noir derrière la modale
            >
                <div className="modal-dialog modal-fullscreen-lg-down modal-dialog-centered">
                    <div className="modal-content border-0 shadow bg-white">
                        <div className="modal-header border-0 justify-content-between align-items-center p-4">
                          <span className="modal-title fs-5 fw-bold" id="downloadModalLabel">
                            Télécharger les plannings et résultats
                          </span>
                            <button
                                type="button"
                                className="btn p-0 border-0"
                                onClick={closeModal}
                                aria-label="Close"
                            >
                                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0Z" fill="#F9C977"></path>
                                    <path d="M15 29L29 15" stroke="white" stroke-width="2" stroke-linecap="round"></path>
                                    <path d="M15 15L29 29" stroke="white" stroke-width="2" stroke-linecap="round"></path>
                                </svg>
                            </button>
                        </div>

                        {/* Body */}
                        <div className="modal-body p-4 pt-0">

                            <p className="text-secondary mb-4 small">
                                Cliquez sur le document de votre choix pour lancer le téléchargement
                            </p>

                            {PdfProspection && PdfProspection.length > 0 ? (
                                PdfProspection.map((pdf, index) => (
                                    <React.Fragment key={pdf.id || index}>
                                        <span className="fw-bold text-dark mb-2 fs-4 d-block">{pdf.titre}</span>
                                        <div className="d-flex flex-column gap-3 mx-auto my-4">
                                            <a href={pdf.url} target="_blank" rel="noreferrer" className="btn btn-dept-select text-start px-4 py-3">
                                                Dates de prospection
                                            </a>
                                            <a href={urlDirectus + 'assets/' + pdf.fichier} target="_blank" rel="noreferrer" className="btn btn-dept-select text-start px-4 py-3">
                                                Résultats d'analyses
                                            </a>
                                        </div>
                                    </React.Fragment>
                                ))
                            ) : (
                                <div className="d-flex flex-column gap-3 mx-auto my-4">
                                    <div className="bg-white border-0 p-4 mb-5 text-center text-muted">
                                        Aucune donnée
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};